import React from 'react';
import { Analytics } from 'global';
import { KibButtonNew } from '@chewy/kib-controls-react';
import { CMS_URL, getPetNewPath } from '../../util/config';
import './landing-page.scss';

const LandingPage = ({ analytics }: { analytics: Analytics }) => {
  const onContinue = () => {
    analytics.trackEvent('new-pet-profile', 'create', 'start', null, {
      sourceView: 'pet-profile-v2',
    });
    if (typeof window !== 'undefined') {
      window.location.href = getPetNewPath();
    }
  };

  const createPetTitle = 'Share what makes your pet special';
  const cratePetSubtitle =
    'Create a pet profile to get special offers, personalized product recommendations, and more. ';
  const createPetButton = 'Create a Pet Profile';
  const createPetImage =
    'https://static.chewy.com/lib/dft/1.6.0/illo/sm/shelter-rescues-give-essentials-3x.png';

  return (
    <div className="add-a-pet__landing">
      <div
        className="add-a-pet__landing--image"
        style={{
          backgroundImage: `url(${createPetImage})`,
        }}
      />
      <div className="add-a-pet__landing--content">
        <div className="add-a-pet__landing--content__inner">
          <h1 className="add-a-pet__landing--heading">{createPetTitle}</h1>
          <p className="add-a-pet__landing--text">{cratePetSubtitle}</p>
          <div className="add-a-pet__landing--buttons">
            <KibButtonNew
              className="kib-button-new--full"
              onClick={onContinue}
              data-testid="start-with-basics-button"
            >
              {createPetButton}
            </KibButtonNew>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
